import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Indicator = styled.div`
  width: 14px;
  height: 14px;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background-color: ${ (props) => props.color };
  border-radius: 20px;
  margin-right: 10px;
`
